(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunorm-fit-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nunorm-fit-guide')) {
    customElements.define(
      'nunorm-fit-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.queue = () => {
            if (this.frame) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;

              if (this.isConnected) {
                this.sync();
              }
            });
          };

          this.onClick = (event) => {
            const button = event.target.closest?.(
              '#menBtn, #womenBtn'
            );

            if (!button || !this.men || !this.women) return;

            if (button === this.men || button === this.women) {
              this.gender =
                button === this.women ? 'women' : 'men';

              this.render();
              this.queue();
            }
          };

          document.addEventListener('click', this.onClick);

          this.treeObserver = new MutationObserver(this.queue);

          this.treeObserver.observe(document.body, {
            childList: true,
            subtree: true
          });

          this.stateObserver = new MutationObserver(this.queue);

          this.queue();
        }

        sync() {
          const main = document.querySelector('main') || document;
          const men = main.querySelector('#menBtn');
          const women = main.querySelector('#womenBtn');

          const placeholder = main.querySelector(
            '[data-nunorm-fit-placeholder]'
          );

          if (
            !men ||
            !women ||
            !placeholder ||
            men.parentElement !== women.parentElement
          ) {
            this.panel?.remove();
            return;
          }

          if (men !== this.men || women !== this.women) {
            this.men = men;
            this.women = women;

            this.stateObserver.disconnect();

            [men, women].forEach((button) => {
              this.stateObserver.observe(button, {
                attributes: true,
                attributeFilter: [
                  'class',
                  'aria-pressed',
                  'aria-selected'
                ]
              });
            });
          }

          if (!this.panel) {
            const template = this.querySelector('template');

            if (!template) return;

            this.panel =
              template.content.firstElementChild.cloneNode(true);
          }

          if (this.panel.parentElement !== placeholder) {
            placeholder.append(this.panel);
          }

          const active = (button) =>
            button.classList.contains('active') ||
            button.getAttribute('aria-pressed') === 'true' ||
            button.getAttribute('aria-selected') === 'true';

          this.gender = active(women)
            ? 'women'
            : active(men)
              ? 'men'
              : (this.gender || 'men');

          this.render();
        }

        render() {
          if (!this.panel) return;

          const female = this.gender === 'women';

          const label = female
            ? this.dataset.womenText
            : this.dataset.menText;

          const position = Math.min(
            100,
            Math.max(
              0,
              Number(
                female
                  ? this.dataset.womenPosition
                  : this.dataset.menPosition
              )
            )
          );

          const heading = this.panel.querySelector(
            '.nunorm-fit__heading'
          );

          if (heading.textContent !== label) {
            heading.textContent = label;
          }

          this.panel.style.setProperty(
            '--nf-position',
            position + '%'
          );
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onClick);

          this.treeObserver?.disconnect();
          this.stateObserver?.disconnect();

          if (this.frame) {
            cancelAnimationFrame(this.frame);
          }

          this.frame = null;
          this.panel?.remove();
          this.panel = null;
          this.men = null;
          this.women = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunorm-product-icons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nunorm-product-icons')) {
    customElements.define(
      'nunorm-product-icons',
      class extends HTMLElement {
        connectedCallback() {
          this.queue = () => {
            if (this.frame) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;

              if (!this.isConnected) return;

              const main =
                document.querySelector('main') || document;

              const target = main.querySelector(
                '[data-nunorm-icons-placeholder]'
              );

              if (!target) {
                this.panel?.remove();
                return;
              }

              if (!this.panel) {
                const template = this.querySelector('template');
                const content =
                  template?.content.firstElementChild;

                if (!content) return;

                this.panel = content.cloneNode(true);
              }

              if (this.panel.parentElement !== target) {
                target.append(this.panel);
              }
            });
          };

          this.observer = new MutationObserver(this.queue);

          this.observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          this.queue();
        }

        disconnectedCallback() {
          this.observer?.disconnect();

          if (this.frame) {
            cancelAnimationFrame(this.frame);
          }

          this.frame = null;
          this.panel?.remove();
          this.panel = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nunorm-shoe-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nunorm-shoe-features')) {
    customElements.define(
      'nunorm-shoe-features',
      class extends HTMLElement {
        connectedCallback() {
          this.queue = () => {
            if (this.frame) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;

              if (!this.isConnected) return;

              const main =
                document.querySelector('main') || document;

              const target = main.querySelector(
                '[data-nunorm-features-placeholder]'
              );

              if (!target) {
                this.panel?.remove();
                return;
              }

              if (!this.panel) {
                const content =
                  this.querySelector('template')
                    ?.content.firstElementChild;

                if (!content) return;

                this.panel = content.cloneNode(true);
              }

              if (this.panel.parentElement !== target) {
                target.append(this.panel);
              }
            });
          };

          this.observer = new MutationObserver(this.queue);

          this.observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          this.queue();
        }

        disconnectedCallback() {
          this.observer?.disconnect();

          if (this.frame) {
            cancelAnimationFrame(this.frame);
          }

          this.frame = null;
          this.panel?.remove();
          this.panel = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
